import { CODE_BY_LOWER, CODE_BY_NAME } from "./constants";

export function toLanguageCode(lang?: string | null): string | undefined {
  if (!lang) {
    return undefined;
  }
  const trimmed = lang.trim();
  if (!trimmed) {
    return undefined;
  }
  const lower = trimmed.toLowerCase();
  return CODE_BY_LOWER.get(lower) ?? CODE_BY_NAME.get(lower) ?? trimmed;
}

export function resolveDisplayLanguage(
  requested: string | undefined,
  defaultLanguage: string | undefined,
  translations: Record<string, unknown> | undefined
): string {
  const fallback = defaultLanguage || "en";
  const requestedCode = toLanguageCode(requested);
  if (!requestedCode) {
    return fallback;
  }

  for (const key of Object.keys(translations || {})) {
    if (toLanguageCode(key) === requestedCode) {
      return key;
    }
  }

  return fallback;
}
